export default __webpack_public_path__ + "static/media/spinner.fb3e9da4.gif";